import {
  cl,
  capitalizeFirstLetter,
} from '../../common/functions';

L.Control.TagFilterButton = L.Control.extend({

  options: {
    header: null,
    container: null,
    storeItemSelector: null,
    onSelectionComplete: null, // the callback function for selected tags
    data: null, // the data to be used for tags popup, it can be array or function
    clearText: null, // the text of the clear button
    filterOnEveryClick: false, // if set as true the plugin do filtering operation on every click event on the checkboxes
    closeOnEveryClick: false,
    openPopupOnHover: false, // if set as true the popup that contains tags will be open at mouse hover time
    ajaxData: null // it can be used for remote data TODO: implement it!
  },

  map: null,
  _container: null,
  tagEl: null,
  filtersHeader: null,
  clearEl: null,
  filterInfo: null,
  selectedTags: [],
  invisibles: null,
  releatedFilterButtons: null,
  layerSources: null,

  /**
   * @function: resetCaches
   * Resets marker caches
   * @param update: if send as true, the @update function is called after cleaning the cache
   * */
  resetCaches: function (update) {
    if (typeof update !== 'boolean')
      update = true;
    this.invisibles = [];
    if (update) {
      this.update();
    }
  },

  /**
   * @function: update
   * Update markers by last selected tags
   *
   * */
  update: function () {
    var filteredCount = this.layerSources.currentSource.hide.call(this, this.layerSources.currentSource);
    this.filtersCounter(filteredCount);
  },

  /**
   * @function: hasFiltered
   * returns true if any tag(s) selected otherwise false
   *
   * */
  hasFiltered: function () {
    return this.selectedTags.length > 0;
  },

  /**
   * @function: registerCustomSource
   * Register @source object for filtering markers by tags. If you want to use this function
   * you must implement @hide function.
   * @param source reference of the new marker source. It must have name and source item
   *
   * */
  registerCustomSource: function (source) {
    if (source.name && source.source && typeof source.source.hide === 'function') {
      this.layerSources.sources[source.name] = source.source;
    } else {
      throw 'Layer source is incompatible';
    }
  },

  /**
   * @function: addToReleated
   * @param other adds another linked tagFilterButton reference to releatedFilterButtons
   *
   * */
  addToReleated: function (other) {
    if (other && other instanceof L.Control.TagFilterButton && this.releatedFilterButtons.indexOf(other) == -1) {
      this.releatedFilterButtons.push(other);
      return other.addToReleated(this);
    }
    console.error("could not add tagFilterButton instance to releated");
    return false;
  },

  /**
   * @function: getInvisibles
   * @param other gets invisibles layers hiding by this plugin
   *
   * */
  getInvisibles: function () {
    return this.invisibles;
  },

  _prepareLayerSources: function () {
    this.layerSources = new Object();
    this.layerSources['sources'] = new Object();

    this.registerCustomSource({
      name: 'default',
      source: {
        hide: function () {
          var releatedLayers = [];

          for (var r = 0; r < this.releatedFilterButtons.length; r++) {
            releatedLayers = releatedLayers.concat(this.releatedFilterButtons[r].getInvisibles());
          }

          var toBeRemovedFromInvisibles = [],
            i;

          // "Fix": add var
          for (var i = 0; i < this.invisibles.length; i++) {
            if (releatedLayers.indexOf(this.invisibles[i]) == -1) {
              // "Fix": add var
              for (var j = 0; j < this.invisibles[i].options.tags.length; j++) {
                if (this.selectedTags.length == 0 || this.selectedTags.indexOf(this.invisibles[i].options.tags[j]) !== -1) {
                  this.map.addLayer(this.invisibles[i]);
                  toBeRemovedFromInvisibles.push(i);
                  break;
                }
              }
            }
          }

          while (toBeRemovedFromInvisibles.length > 0) {
            this.invisibles.splice(toBeRemovedFromInvisibles.pop(), 1);
          }

          var removedMarkers = [];
          var totalCount = 0;

          if (this.selectedTags.length > 0) {
            this.map.eachLayer(
              function (layer) {
                if (layer && layer.options && layer.options.tags) {
                  totalCount++;
                  if (releatedLayers.indexOf(layer) == -1) {
                    var found = false;
                    for (var i = 0; i < layer.options.tags.length; i++) {
                      found = this.selectedTags.indexOf(layer.options.tags[i]) !== -1;
                      if (found) {
                        break;
                      }
                    }
                    if (!found) {
                      removedMarkers.push(layer);
                    }
                  }
                }
              }.bind(this)
            );

            for (i = 0; i < removedMarkers.length; i++) {
              this.map.removeLayer(removedMarkers[i]);
              this.invisibles.push(removedMarkers[i]);
            }
          }

          return totalCount - removedMarkers.length;
        }
      }
    });
    this.layerSources.currentSource = this.layerSources.sources['default'];
  },


  initialize: function (options) {
    this.invisibles = [];
    this.releatedFilterButtons = [];
    L.Util.setOptions(this, options || {});
    this._prepareLayerSources();
  },

  /**
   * Add counter to Header
   * */

  /**
   * Items Events
   * */
  checkItem: function (item) {
    item.dataset.checked = "checked";
  },

  uncheckItem: function (item) {
    item.dataset.checked = "";
  },

  clickItem: function (e) {
    L.DomEvent.stop(e);
    let li = this.element;
    let context = this.context;
    if (!li.dataset.checked) {
      context.checkItem(li);
    } else {
      context.uncheckItem(li);
    }
    if (context.options.filterOnEveryClick) {
      context.filter.call(context);
    }
    if (context.options.closeOnEveryClick) {
      const filterContainer = document.querySelector(".filters__wrapper");
      if (filterContainer && filterContainer.classList.contains('is-opened')) {
        filterContainer.classList.remove("is-opened");
      }
    }
  },


  /**
  * Filters
  * */
  makeFiltersList: function (datas) {
    [...datas].forEach(data => {
      // elements INIT
      let listElement = L.DomUtil.create('li', 'list__element', this.tagEl);
      let textElement = L.DomUtil.create('span', 'element__text', listElement);
      let value = data;

      // Exception pour la gestion des couleurs dans les filtres
      if (typeof value === 'object') {
        listElement.dataset.value = value.name;
        listElement.style.setProperty("--markerColor", value.color);
        textElement.innerHTML = capitalizeFirstLetter(value.name);
        L.DomUtil.create('span', 'element__checkbox', listElement);
        // events bind
        L.DomEvent.addListener(listElement, 'click', this.clickItem.bind({ context: this, element: listElement }));
        L.DomEvent.addListener(textElement, 'click', function (e) {
          L.DomEvent.stop(e);
          this.context.clickItem.call(this, e);
        }.bind({ context: this, element: listElement }));
      } else {
        // Exception pour les catégories de Filtres
        if (value.startsWith('optGroup__separator--')) {
          let splitedValue = value.split("--");
          if (splitedValue.length !== 1) {
            value = capitalizeFirstLetter(splitedValue[1]);
          } else {
            value = capitalizeFirstLetter(splitedValue[0]);
          }
          listElement.dataset.value = value.toLowerCase();
          listElement.classList.add("list__element--category");
          textElement.innerHTML = value;
          L.DomEvent.addListener(textElement, 'click', function (e) {
            L.DomEvent.stop(e);
          });
        } else {
          listElement.dataset.value = value;
          textElement.innerHTML = capitalizeFirstLetter(value);
          L.DomUtil.create('span', 'element__checkbox', listElement);
          // events bind
          L.DomEvent.addListener(listElement, 'click', this.clickItem.bind({ context: this, element: listElement }));
          L.DomEvent.addListener(textElement, 'click', function (e) {
            L.DomEvent.stop(e);
            this.context.clickItem.call(this, e);
          }.bind({ context: this, element: listElement }));
        }
      }
    });
  },

  filtersCounter: function (filteredCount) {
    if (this.selectedTags.length > 0) {
      this.filterInfo.innerText = filteredCount.toString();
      this.filterInfo.style.display = "";
    } else {
      this.filterInfo.style.display = "none";
    }
  },

  clearFilters: function (e) {
    L.DomEvent.stop(e);
    this.selectedTags = [];
    let childCount = this.tagEl.childElementCount,
      children = this.tagEl.children,
      childCheckbox, i;

    this.selectedTags = [];

    for (i = 0; i < childCount; i++) {
      childCheckbox = children[i];
      if (childCheckbox) {
        this.uncheckItem(childCheckbox);
      }
    }

    if (this.options.filterOnEveryClick) {
      this.filter();
    }
  },

  hideFilters: function () {
    const body = document.querySelector("body");
    if (body) {
      document.addEventListener('click', (e) => {
        if (!e.target.closest(`.${this._container.classList[0]}`)) {
          if (this._container.classList.contains('is-opened')) {
            this._container.classList.remove("is-opened");
          }
        }
      }, false);
    }
  },

  toggleFilters: function () {
    cl("ayaya");
    this._container.classList.toggle("is-opened");
  },

  filter: function (withTags) {
    let checkboxContainer = (this._container.getElementsByTagName('div')[0]),
      childCount = this.tagEl.childElementCount,
      children = this.tagEl.children,
      childCheckbox, i, j;

    this.selectedTags = [];

    if (withTags) {
      let acceptingTags = [];
      for (let i = 0; i < withTags.length; i++) {
        if (this.options.data.indexOf(withTags[i]) !== -1) {
          acceptingTags.push(withTags[i]);
        }
      }
      withTags = acceptingTags;
    }

    if (!withTags || !withTags.length) {
      for (let i = 0; i < childCount; i++) {
        childCheckbox = children[i];
        if (childCheckbox && childCheckbox.dataset.checked) {
          this.selectedTags.push(childCheckbox.dataset.value);
        }
      }
    } else {
      this.selectedTags = withTags;
    }

    let filteredCount = this.layerSources.currentSource.hide.call(this, this.layerSources.currentSource);
    this.filtersCounter(filteredCount);

    if (this.options.onSelectionComplete && typeof this.options.onSelectionComplete == 'function') {
      this.options.onSelectionComplete.call(this, this.selectedTags);
    }


    //onclick filter action
    const tags = this.selectedTags;
    const itemSelector = this.options.storeItemSelector;
    if (tags && itemSelector) {
      let tagString = '';
      [...this.selectedTags].forEach(tag => {
        tagString += `:not(.${tag})`;
      });
      const filter = element => {
        [...element].forEach(filteredStoreItem => {
          filteredStoreItem.style.display = 'none';
        });
      };
      const unfilter = element => {
        [...element].forEach(storeItem => {
          storeItem.style.display = 'flex';
        });
      };
      if (!!tags.length) {
        const storeItems = document.querySelectorAll(`${itemSelector}`);
        unfilter(storeItems);
        const filteredStoreItems = document.querySelectorAll(`${itemSelector}${tagString}`);
        filter(filteredStoreItems);
      } else {
        const storeItems = document.querySelectorAll(`${itemSelector}`);
        unfilter(storeItems);
      }
    }
  },


  /**
   * DOM HTML Container maker
   * */
  addTo: function (map) {
    const options = this.options;
    const filtersContainer = document.querySelector(options.container);;
    const data = options.data;
    let showFunction = this.toggleFilters;

    // Bind event to body
    this.hideFilters();

    // Creation du container principal
    this._container = L.DomUtil.create('div', 'filters__wrapper', filtersContainer);

    // Header
    this.filtersHeader = L.DomUtil.create('div', 'filters__header', this._container);
    L.DomEvent.addListener(this.filtersHeader, 'click', showFunction.bind(this));
    L.DomEvent.disableClickPropagation(this.filtersHeader);
    L.DomEvent.disableScrollPropagation(this.filtersHeader);
    this.filtersHeader.innerHTML = /*html*/ `<span class="header__text" title="${this.options.header}">${this.options.header}</span>`;
    // Nombre de filtres
    this.filterInfo = L.DomUtil.create('span', 'header__counter', this.filtersHeader);
    this.filtersCounter(0);

    // Remplis la liste des filtres
    this.tagEl = L.DomUtil.create('ul', 'filters__list', this._container);
    if (data) {
      if (typeof data === 'function') {
        this.makeFiltersList(data());
      } else {
        this.makeFiltersList(data);
      }
    }
    // Reset button
    if (this.options.clearText) {
      this.clearEl = L.DomUtil.create('li', 'list__element list__element--clear', this.tagEl);
      this.clearEl.title = `${this.options.clearText}`;
      this.clearEl.innerHTML = `${this.options.clearText}`;
      L.DomEvent.addListener(this.clearEl, 'click', this.clearFilters.bind(this));
    }
    return this;
  },


  /**
   * Marker cluster filter gestion
   * */
  enableMCG: function (mcgInstance) {
    this.registerCustomSource({
      name: 'mcg',
      source: {
        mcg: mcgInstance,
        hide: function (layerSource) {
          var releatedLayers = [];

          for (var r = 0; r < this.releatedFilterButtons.length; r++) {
            releatedLayers = releatedLayers.concat(this.releatedFilterButtons[r].getInvisibles());
          }

          var toBeRemovedFromInvisibles = [],
            i,
            toAdd = [];

          for (var i = 0; i < this.invisibles.length; i++) {
            if (releatedLayers.indexOf(this.invisibles[i]) == -1) {
              for (var j = 0; j < this.invisibles[i].options.tags.length; j++) {
                if (this.selectedTags.length == 0 || this.selectedTags.indexOf(this.invisibles[i].options.tags[j]) !== -1) {
                  //this.map.addLayer(this.invisibles[i]);
                  toAdd.push(this.invisibles[i]);
                  toBeRemovedFromInvisibles.push(i);
                  break;
                }
              }
            }
          }

          // Batch add into MCG
          layerSource.mcg.addLayers(toAdd);

          while (toBeRemovedFromInvisibles.length > 0) {
            this.invisibles.splice(toBeRemovedFromInvisibles.pop(), 1);
          }

          var removedMarkers = [];
          var totalCount = 0;

          if (this.selectedTags.length > 0) {
            //this.map.eachLayer(
            layerSource.mcg.eachLayer(
              function (layer) {
                if (layer && layer.options && layer.options.tags) {
                  totalCount++;
                  if (releatedLayers.indexOf(layer) == -1) {
                    var found = false;
                    for (var i = 0; i < layer.options.tags.length; i++) {
                      found = this.selectedTags.indexOf(layer.options.tags[i]) !== -1;
                      if (found) {
                        break;
                      }
                    }
                    if (!found) {
                      removedMarkers.push(layer);
                    }
                  }
                }
              }.bind(this)
            );

            for (i = 0; i < removedMarkers.length; i++) {
              //this.map.removeLayer(removedMarkers[i]);
              this.invisibles.push(removedMarkers[i]);
            }

            // Batch remove from MCG
            layerSource.mcg.removeLayers(removedMarkers);
          }

          return totalCount - removedMarkers.length;
        }
      }
    });

    this.layerSources.currentSource = this.layerSources.sources['mcg'];
  },
});

L.control.tagFilterButton = function (options) {
  return new L.Control.TagFilterButton(options);
};

const tagFilterButtonCustom = L.control.tagFilterButton;


export { tagFilterButtonCustom }
